const key = (name: string, id: string | number) => `ph-once:${name}:${id}`

export function shouldSendOnce(
  name: string,
  id: string | number,
  ttlMs = 1000 * 60 * 10
) {
  try {
    const k = key(name, id)
    const raw = sessionStorage.getItem(k)
    const now = Date.now()
    if (!raw) {
      sessionStorage.setItem(k, String(now))
      return true
    }
    const last = Number(raw)
    if (Number.isFinite(last) && now - last > ttlMs) {
      sessionStorage.setItem(k, String(now))
      return true
    }
    return false
  } catch {
    return true
  }
}
